import React from 'react';
import { GroupAddons } from './Addons/Group';
import { ServiceData, SlotService } from '../../../../utils/state/types';
import { mapToArray } from '../../../../utils';
import { useFormActions } from '../../Hooks/useFormActions';
import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';

export const AddonsDetails = ({
  serviceData,
}: {
  serviceData: ServiceData;
}) => {
  const { onAddonSelect, onAddonQuantityChange } = useFormActions();
  const singleService = mapToArray<SlotService>(serviceData.slotServices)[0];
  const { addOnByGroup, selectedAddons = {}, service } = singleService;
  const serviceSlotId = singleService.nestedSlot.lineItemId;
  if (service.type === ServiceType.APPOINTMENT) {
    return null;
  }
  return (
    <div>
      {addOnByGroup
        ?.filter((group) => group.addOns?.length)
        .map((group) => {
          return (
            <GroupAddons
              key={group.id}
              name={group.name!}
              addOns={group.addOns!}
              maxQuantity={group.maxNumberOfAddOns ?? undefined}
              prompt={group.prompt ?? undefined}
              selectedAddons={selectedAddons ?? {}}
              onAddonSelect={(addonId, isSelected) =>
                onAddonSelect(addonId, isSelected, serviceSlotId)
              }
              onAddonQuantityChange={(addonId, quantity) =>
                onAddonQuantityChange(addonId, quantity, serviceSlotId)
              }
            />
          );
        })}
    </div>
  );
};
